const FrontPage = (($) => {
  let _els = {};
  let _headerHeight;
  let _windowWidth = window.innerWidth;
  let _mobileNumToShow = 3;
  let _mobileSubNumToShow = 2;
  let _numRestaurants;

  let _restaurantTransforms = [];
  let _subPanelTransforms = [];

  const _break = 768;

  const init = () => {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    _initScroll();

    if (_windowWidth < _break) {
      _computeNav();
    }
  };

  const _initScroll = () => {
    _els.header = $('#primary-header .navbar');
    _els.restaurantNavContainer = $('.content__restaurants .nav--restaurants');
    _els.restaurantSubNavContainers = $('.content__restaurants .panels .nav--locations');
    _els.panelsContainer = $('.content__restaurants .panels');
    _els.panels = $('.content__restaurants .panels .panel');
    _els.restaurantNavItems = $('.content__restaurants .nav--restaurants .item');
    _els.restaurantNavLinks = $('.content__restaurants .nav--restaurants .item a');
    _els.restaurantSubNavItems = $('.content__restaurants .panels .nav--locations .item');

    _numRestaurants = _els.restaurantNavLinks.length;
    _headerHeight = _els.header.outerHeight();

    const panels = gsap.utils.toArray('.content__restaurants .panel');
    const navLinks = gsap.utils.toArray('.content__restaurants .nav--restaurants .item a');
    const subNavLinks = gsap.utils.toArray('.content__restaurants .nav--locations .item a');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.content__restaurants',
        scrub: true,
        pin: true,
        start: 'top ' + (_headerHeight),
        end: '+=' + subNavLinks.length * 1000,
        // markers: true,
        snap: {
          snapTo: 'labels', // snap to the closest label in the timeline
          duration: { min: 0.2, max: 1 }, // the snap animation should be at least 0.2 seconds, but no more than 1 seconds (determined by velocity)
          delay: 0.2, // wait 0.1 seconds from the last scroll event before doing the snapping
          ease: 'power1.inOut', // the ease of the snap animation ("power3" by default)
        },
      },
    });

    panels.forEach((panel, i) => {
      let $subPanels = $(panel).find('.sub-panel');
      let subPanels = gsap.utils.toArray($subPanels);
      let curSubNavLinks = $(panel).find('.nav--locations .item a');

      _subPanelTransforms[i] = {
        length: curSubNavLinks.length,
        transforms: [],
      };

      gsap.set(panel, {
        zIndex: panels.length - i,
      });

      tl.from(
        panel,
        {
          x: i === 0 ? '0' : '+=33%',
          opacity: i === 0 ? '1' : '0',
          ease: 'none',
          duration: 2,
          // delay: i === 0 ? '0' : '1',
          onStart: () => {
            let currentId = panel.getAttribute('data-id');
            let currentEl = _els.restaurantNavLinks.filter('[data-jump="panel-' + currentId + '"]');
            _els.restaurantNavLinks.removeClass('active');
            currentEl.addClass('active');

            if (_windowWidth < _break) {
              _adjustNavPosition(i);
            }
          },
          onReverseComplete: () => {
            let currentId = panel.getAttribute('data-id');
            let prevId = currentId > 0 ? currentId - 1 : 0;
            let prevEl = _els.restaurantNavLinks.filter('[data-jump="panel-' + prevId + '"]');
            _els.restaurantNavLinks.removeClass('active');
            prevEl.addClass('active');

            if (_windowWidth < _break) {
              _adjustNavPosition(prevId);
            }
          },
        },
        '+=0',
      );

      tl.set(panel, {
        zIndex: panels.length,
      });

      tl.addLabel('panel-' + i);

      subPanels.forEach((location, j) => {
        gsap.set(location, {
          zIndex: subPanels.length - j,
        });

        tl.from(
          location,
          {
            opacity: j === 0 ? '1' : '0',
            ease: 'none',
            duration: 2,
            delay: j === 0 ? '1' : '0',
            onStart: () => {
              let currentId = location.getAttribute('data-id');
              let currentEl = curSubNavLinks.filter('[data-jump="sub-panel-' + currentId + '"]');
              curSubNavLinks.removeClass('active');
              currentEl.addClass('active');

              if (_windowWidth < _break) {
                _adjustSubNavPosition(j, i);
              }
            },
            onReverseComplete: () => {
              let locs = location.getAttribute('data-id').split('-');
              let currentParent = locs[0];
              let currentId = locs[1];
              let prevId = currentId > 0 ? currentId - 1 : 0;
              let prevEl = curSubNavLinks.filter(
                '[data-jump="sub-panel-' + currentParent + '-' + prevId + '"]',
              );
              curSubNavLinks.removeClass('active');
              prevEl.addClass('active');

              if (_windowWidth < _break) {
                _adjustSubNavPosition(prevId, i);
              }
            },
          },
          '+=0',
        );

        tl.set(location, {
          zIndex: subPanels.length,
        });

        tl.addLabel('sub-panel-' + i + '-' + j);

        tl.to(
          location,
          {
            opacity: j === subPanels.length - 1 ? '1' : '0',
            ease: 'none',
            duration: 2,
            delay: 1,
          },
          '+=0',
        );

        tl.set(location, {
          zIndex: 0,
        });
      });

      tl.to(
        panel,
        {
          x: i === panels.length - 1 ? '0' : '-=33%',
          opacity: i === panels.length - 1 ? '1' : '0',
          ease: 'none',
          duration: 2,
          delay: 1,
        },
        '+=0',
      );

      tl.set(panel, {
        zIndex: 0,
      });
    });

    navLinks.forEach((link, i) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // grab the ScrollTrigger instance
        let st = tl.scrollTrigger;

        // calculate the scroll position needed for the label and go there
        const percent = tl.labels[e.target.getAttribute('data-jump')] / tl.totalDuration();
        const scrollPos = st.start + (st.end - st.start) * percent;
        gsap.to(window, { duration: 0.5, scrollTo: scrollPos });
      });
    });

    subNavLinks.forEach((link, i) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // grab the ScrollTrigger instance
        let st = tl.scrollTrigger;

        // calculate the scroll position needed for the label and go there
        const percent = tl.labels[e.target.getAttribute('data-jump')] / tl.totalDuration();
        const scrollPos = st.start + (st.end - st.start) * percent;

        gsap.to(window, { duration: 1, scrollTo: scrollPos });
      });
    });

    window.addEventListener('resize', (e) => {
      _computeNav();
      ScrollTrigger.refresh();
    });
  };

  const _computeNav = () => {
    _windowWidth = window.innerWidth;

    if (_windowWidth >= _break) {
      // clear any previously set styles on nav
      _els.restaurantNavItems.removeAttr('style');
      _els.restaurantSubNavItems.removeAttr('style');
      _els.restaurantNavContainer.removeAttr('style');
      _els.restaurantSubNavContainers.removeAttr('style');
      return;
    }

    let totalWidth = _els.panelsContainer.innerWidth() - 30; // account for padding
    let navItemWidth = totalWidth / _mobileNumToShow;
    let subNavItemWidth = totalWidth / _mobileSubNumToShow;

    $.each(_els.panels, (i, val) => {
      let transformVal;
      let curSubNavItems = $(val).find('.nav--locations .item');

      if (i < _mobileNumToShow - 1) {
        transformVal = 0;
      } else if (i >= _numRestaurants - 1) {
        transformVal = navItemWidth * (_numRestaurants - _mobileNumToShow);
      } else {
        transformVal = navItemWidth * (i - 1);
      }

      _restaurantTransforms[i] = transformVal;

      $.each(curSubNavItems, (j, val) => {
        let subTransformVal;

        if (j === 0) {
          subTransformVal = 0;
        } else if (j === curSubNavItems.length - 1) {
          subTransformVal = subNavItemWidth * (j - 1);
        } else {
          subTransformVal = subNavItemWidth * j - subNavItemWidth * 0.5;
        }

        _subPanelTransforms[i].transforms[j] = subTransformVal;
      });
    });

    _els.restaurantNavItems.css({ width: navItemWidth + 'px' });
    _els.restaurantSubNavItems.css({ width: subNavItemWidth + 'px' });
  };

  const _adjustNavPosition = (index) => {
    _els.restaurantNavContainer.css({
      transform: 'translateX(' + '-' + _restaurantTransforms[index] + 'px)',
    });
  };

  const _adjustSubNavPosition = (index, parentIndex) => {
    _els.panels
      .eq(parentIndex)
      .find('.nav--locations')
      .css({
        transform: 'translateX(' + '-' + _subPanelTransforms[parentIndex].transforms[index] + 'px)',
      });
  };

  module.exports = {
    init: init,
  };
})(jQuery);
